import posthog from "posthog-js";

posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
  api_host: "/ingest",
  ui_host: "https://eu.posthog.com",
  defaults: '2025-05-24',
  capture_exceptions: true, // This enables capturing exceptions using Error Tracking, set to false if you don't want this
  debug: process.env.NODE_ENV === "development",
  persistence: 'localStorage',
  session_recording: {
    maskAllInputs: false,
    maskInputOptions: {
      password: true, // Highly recommended as a minimum!!
      // color: false,
      // date: false,
      // 'datetime-local': false,
      email: true,
      // month: false,
      // number: false,
      // range: false,
      // search: false,
      tel: true,
      // text: false,
      // time: false,
      // url: false,
      // week: false,
      // textarea: false,
      // select: false,
    },
    maskTextSelector: ".sensitive, #vehicle_reg" // masks all elements with the class "sensitive" or the ID "vehicle_reg". This does not apply to input elements.
  },
    
});